import React, { useContext } from 'react'
import { Logo, hamburger, menu, shoppingcart } from '../assets/images'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import authContext from '../context/auth-context'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { CartContext } from '../context/CartContext'

const NavbarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    position: relative;
    padding:18px 10px 18px 0px;
    background-color:var(--black);
    transition:all 0.5s ease-in-out;
    img{
        height:120px;
        cursor:pointer;
    }
    div{
        flex:0.7;
        padding:0px 10px 0px 50px;
        display:flex;
        justify-content:space-between;
        h4 { 
            cursor:pointer;
            font-weight:500;
            letter-spacing:1.1px;
            font-size: 18px;
            color:var(--gray);
            transition:all 0.2s ease-in-out;
            &:hover{
                color: #f8d720dd;
            }
        }
    }
    @media screen and (min-width:1441px){
        div{
          margin-top:60px;
          h4{
            font-size:22px;
          }
        }
    }
    @media screen and (max-width:1440px){
      img{
        height:100px;
      }
      div{
        flex:0.8;
        margin-top:40px;
        h4{
          font-size:18px;
        }
      }
    }
    @media screen and (max-width:1024px){
      img{
        height:60px;
      }
      div{
        flex:0.9;
        h4{
          font-size:16px;
        }
      }
    }
    @media screen and (max-width:768px){
      margin-bottom:20px;
      img{
        height: 80px;
        margin-top: 30px;
        box-shadow: inset 0px 0px 7px -2px var(--border);
        border-radius: 10px;
        padding: 10px;
      }
      div{
        display:none;
      }
      
    }
`

const NavbarWrapperMobile = styled.div`
  display:none;
  @media screen and (max-width:768px){
    display:flex
  }
  button{
    position:absolute;
    right:10px;
    top:120px;
    outline:none;
    border:1px solid var(--border);
    img{
      width:40px;
      height:30px;
      padding:5px;
      margin: 3px;
      background-color: var(--border);
      animation: all .5s ease-in-out;
    }
  }
  div{
    nav{
      display:flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 300px !important;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      background-color: var(--border) !important;
      box-shadow:0px 0px 32px -1px var(--border) !important;
    }
    img{
      align-self:center;
      position:absolute;
      top:10px;
      width:90%;
      background-color:var(--black);
      border-radius:10px;
      }
    h4{
      background-color:transparent;
      padding-left:15px;
      color:black;
      font-size:17px;
      cursor: pointer;
      margin:10px 0px;
    }
  }

`
const Navbar = () => {
  const navigate = useNavigate()
  const {state, logout, userInfo} = useContext(authContext)
  const {cart} = useContext(CartContext)
  const [isOpen, setIsOpen] = React.useState(false)
  const toggleDrawer = () => {
      setIsOpen((prevState) => !prevState)
  }
  return (
    <>
    <NavbarWrapper>
      <img onClick={()=>navigate('/')} src={Logo} alt='Eagle Logo'/>
      <div>
        <h4 onClick={()=>navigate('/AboutMe')}>About Me</h4>
        <h4 onClick={()=>navigate('/MyWork')}>My Work</h4>
        {/* <h4 onClick={()=>navigate('/Resources')}>Resource</h4> */}
        <h4 onClick={()=>navigate('/WebShop')}>Planner Webshop</h4>
        <h4 onClick={()=>navigate('/ContactMe')}>Contact Me</h4>
        {state.userInfo || userInfo ? 
          <h4 onClick={()=>logout()}>Logout</h4>
        :
          <h4 onClick={()=>navigate('/Authentication')}>Login</h4>
        }
        <span style={{position:'relative'}} onClick={()=>navigate('/Cart')}>
          <img style={{height:'20px'}} src={shoppingcart} alt=''/>
          <h4 style={{
            position: 'absolute',
            top: '0px',
            fontSize: '13px',
            right: '-26px',
            background: 'transparent',
          }}>({cart.length})</h4>
        </span>
      </div>
    </NavbarWrapper>
    <NavbarWrapperMobile>
      <button onClick={toggleDrawer}>
        {isOpen?
        <img src={menu} alt='Logo'/> :
        <img src={hamburger} alt='Logo'/> 
      }
      </button>
        <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction='left'
        >
          <img src={Logo} alt='Logo' />
          <h4 onClick={()=>{toggleDrawer();navigate('/AboutMe')}}>About Me</h4>
          <h4 onClick={()=>{toggleDrawer();navigate('/MyWork')}}>My Work</h4>
          {/* <h4 onClick={()=>{toggleDrawer();navigate('/Resources')}}>Resource</h4> */}
          <h4 onClick={()=>{toggleDrawer();navigate('/WebShop')}}>Planner Webshop</h4>
          <h4 onClick={()=>{toggleDrawer();navigate('/ContactMe')}}>Contact Me</h4>
          {state.userInfo || userInfo ? 
            <h4 onClick={()=>{toggleDrawer();logout()}}>Logout</h4>
          :
            <h4 onClick={()=>{toggleDrawer();navigate('/Authentication')}}>Login</h4>
          }
          <h4 onClick={()=>{toggleDrawer();navigate('/Cart')}}>Cart({cart.length})</h4>
      </Drawer>
    </NavbarWrapperMobile>
    </>

  )
}

export default Navbar